import React from 'react';
import Image from 'next/image';

import {Checkbox, Text} from '#component/base';

import {SkipNextOrderModalItemProps} from './SkipNextOrderModal.types';

import {
  checkboxContainer,
  imageContainer,
  infoContainer,
  optionContainer,
  skipAlert,
} from './SkipNextOrderModal.css';

export function SkipNextOrderModalItem({
  productId,
  title,
  image,
  selected,
  setSelected,
  hasSupplementPaused,
}: SkipNextOrderModalItemProps) {
  return (
    <div className={optionContainer}>
      <div className={imageContainer}>
        <div className={checkboxContainer}>
          <Checkbox
            onChange={() => setSelected(productId, !selected, hasSupplementPaused)}
            checked={selected}
          />
        </div>
        <Image src={image} width={90} height={60} style={{borderRadius: 10}} alt="pill" />
      </div>
      <div className={infoContainer}>
        <Text as="p" color="burgundy">
          {title}
        </Text>
        {selected && (
          <Text as="p" className={skipAlert} color="doveGray">
            This will be skipped in your next order
          </Text>
        )}
      </div>
    </div>
  );
}
